import { render, staticRenderFns } from "./Importador.vue?vue&type=template&id=91a24b1e"
import script from "./Importador.vue?vue&type=script&lang=js"
export * from "./Importador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports